import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { theme } from '../../../theme';
import { GoTabProps } from '../GoSidebar.types';
import * as classes from './GoSidebarMobileTab.ve.css';

export const GoSidebarMobileTab = ({ label, Icon, isActive, href }: GoTabProps) => (
    <Container
        as="a"
        href={href}
        display="flex"
        direction="column"
        borderRadius="lg"
        cursor="pointer"
        style={{
            textDecoration: 'none',
            backgroundColor: isActive ? theme.colors.grey1100 : 'transparent',
            color: isActive ? theme.colors.textOnDark : theme.colors.grey700,
        }}
        className={classes.hoverTrigger}
    >
        <Stack gap="3" alignItems="center" paddingX="2" paddingY="3">
            <Icon size={24} />
            <Typography size="b_sm" fontWeight="semibold">
                {label}
            </Typography>
        </Stack>
    </Container>
);
